import React from 'react';
import { Check, Plus, Trash2 } from 'lucide-react';

interface Task {
  id: string;
  text: string;
  completed: boolean;
}

interface TaskListProps {
  tasks: Task[];
  onTaskAdd: () => void;
  onTaskToggle: (taskId: string) => void;
  onTaskDelete: (taskId: string) => void;
  onTaskTextChange: (taskId: string, text: string) => void;
}

export function TaskList({ tasks, onTaskAdd, onTaskToggle, onTaskDelete, onTaskTextChange }: TaskListProps) {
  return (
    <div className="space-y-4">
      <div className="flex items-center justify-between">
        <label className="block text-sm font-medium text-gray-600">Daily Tasks</label>
        <button
          type="button"
          onClick={(e) => {
            e.preventDefault();
            onTaskAdd();
          }}
          className="flex items-center gap-2 px-3 py-1 text-sm bg-custom-orange-100 text-custom-orange-500 rounded-xl hover:bg-custom-orange-200 transition-all"
        >
          <Plus size={16} />
          Add Task
        </button>
      </div>
      
      <div className="space-y-2">
        {tasks.map((task) => (
          <div key={task.id} className="flex items-start gap-3 group bg-custom-orange-50/50 rounded-xl px-3 py-2">
            <button
              type="button"
              onClick={(e) => {
                e.preventDefault();
                onTaskToggle(task.id);
              }}
              className={`flex-shrink-0 w-6 h-6 mt-1 rounded-full border-2 flex items-center justify-center transition-all ${
                task.completed
                  ? 'bg-custom-orange-400 border-custom-orange-400'
                  : 'border-gray-300 hover:border-custom-orange-300'
              }`}
            >
              {task.completed && <Check size={14} className="text-white" />}
            </button>
            
            <div className="flex-grow min-w-0">
              <textarea
                value={task.text}
                onChange={(e) => onTaskTextChange(task.id, e.target.value)}
                className={`w-full bg-transparent border-none focus:outline-none focus:ring-0 resize-none ${
                  task.completed ? 'text-gray-400 line-through' : 'text-gray-700'
                }`}
                placeholder="Enter task..."
                rows={Math.ceil(task.text.length / 40)} // Adjust rows based on content
                style={{
                  minHeight: '24px',
                  height: 'auto',
                  overflow: 'hidden'
                }}
                onInput={(e) => {
                  const target = e.target as HTMLTextAreaElement;
                  target.style.height = 'auto';
                  target.style.height = `${target.scrollHeight}px`;
                }}
              />
            </div>
            
            {!task.text.includes('Meditation') && 
             !task.text.includes('Stretch') && 
             !task.text.includes('Breath') && 
             !task.text.includes('Vagus nerve exercise') && 
             !task.text.includes('Journal') && 
             !task.text.includes('Visualization') && 
             !task.text.includes('Affirmations') && (
              <button
                type="button"
                onClick={(e) => {
                  e.preventDefault();
                  onTaskDelete(task.id);
                }}
                className="flex-shrink-0 text-gray-400 hover:text-red-400 transition-all mt-1 opacity-0 group-hover:opacity-100"
              >
                <Trash2 size={16} />
              </button>
            )}
          </div>
        ))}
      </div>
    </div>
  );
}